export default __webpack_public_path__ + "static/media/prichod.f53d7cbc.jpeg";